<template>
  <div>
    <slot/>
  </div>
</template>

<script>
import setLayoutClass from '@/utils/setLayoutClass'
import '@/styles/website/main.scss'

export default {
  name: 'WebsiteLayout',
  data () {
    return {
      title: 'Elsazeit'
    }
  },
  mounted () {
    setLayoutClass('layout-website')
  }
}
</script>

<style lang="scss" src="@/styles/website/main.scss"></style>
